import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Absence from '../../components/tables/Absence.jsx';
import { useRef } from 'react';
import { getAllEmployees } from '../../services/EmployeeService';
import PageHeader from '../../components/headers/Header'
import AbsenceDetailsModal from '../../components/DViews/AbsenceDetailsModal';
import AbsenceCalendar from '../../components/calendars/AbsenceCalendar';
import DayDetailsModal from '../../components/DViews/CDayDetails.jsx';
import AbsenceDashboard from '../../components/dash/AbsenceDash';
import JustificationUploadModal from '../../components/DViews/JUModal.jsx';
import ElegantAddButton from '../../components/btns/AddButton.jsx';
import AbsenceDetailsDialog from '../../components/DViews/StoringAbsenceDM.jsx';

import { getAllAbsences, getMyAbsences, getAllStagedAbsences, deleteAbsence } from '../../services/absenceAPIs';
import { exportToPdf } from '../../utils/exportToPdf';
import { useMediaQuery, Fab, Typography, Box } from '@mui/material';

import '../../components/leaves/Leaves.css';

const NotEmployee = localStorage.getItem('userRole') !== 'EMPLOYEE';

const DayOff = () => {
  const navigate = useNavigate();
  const [IsEmployee, setIsEmployee] = useState(localStorage.getItem('userRole') === 'EMPLOYEE');

  const [stagedAbsences, setStagedAbsences] = useState([]);

  console.log(localStorage.getItem('token'));
  const isLargeScreen = useMediaQuery('(min-width: 1600px)');

  const location = useLocation(); // Get location

  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [selectedAbsence, setSelectedAbsence] = useState(null);
  const [selecteToStore, setSelectToStore] = useState(null);
  const [employees, setEmployees] = useState([]);

  const [currentDate] = useState(new Date('2025-06-19T10:26:00+01:00'));
  // const [activeTab, setActiveTab] = useState('overview');
  const [activeTab, setActiveTab] = useState(IsEmployee ? 'add' : 'overview');
  const [showEmployeeCard, setShowEmployeeCard] = useState(false);

  // Calendar specific states
  const [selectedCalendarDate, setSelectedCalendarDate] = useState(null);
  const [dayAbsences, setDayAbsences] = useState([]);
  const [showDayDetailsModal, setShowDayDetailsModal] = useState(false);

  const [openStoreDialog, setOpenStoreDialog] = useState(false);

  const [selectedUpload, setSelectedUpload] = useState(null);

  // Initialize filters with potential state from navigation
  const initialFilters = {
    type: '',
    status: '',
    department: '',
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    search: '',
    includeLateness: true
  };

  const [filters, setFilters] = useState(initialFilters);

  useEffect(() => {
    const state = location.state || {};
    setActiveTab(state.targetTab || (IsEmployee ? 'add' : 'overview'));

    if (state.filters) {
      setFilters(prevFilters => ({
        ...prevFilters,
        year: state.filters.year || prevFilters.year,
        month: state.filters.month || prevFilters.month,
        office:
          state.filters.office === 'all'
            ? ''
            : state.filters.office || prevFilters.office,
      }));
    }

    if (state.targetTab) delete state.targetTab;
  }, [location.state, IsEmployee]);

  useEffect(() => {
    console.log('selected absence:', selectedAbsence)
  }, [selectedAbsence]);



  // Data fetching
  useEffect(() => {
    const fetchData = async () => {
      try {
        const allEmployees = await getAllEmployees();
        setEmployees(allEmployees);
        console.log("All Employees:", allEmployees);
        console.log("All Employees:", employees);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const [absences, setAbsences] = useState([]);

  const fetchAbsences = async () => {
    try {
      let data = [];
      const stagedAbsencesData = await getAllStagedAbsences();
      if (IsEmployee) {
        data = await getMyAbsences();
      } else {
        data = await getAllAbsences();
      }
      setStagedAbsences(stagedAbsencesData);
      setAbsences(data.filter(abs => abs.ty_pe === 'DAY_OFF'));
      console.log('Absence management absences:', data);
    } catch (error) {
      console.error('Error fetching absences:', error);
    }
  };

  // Initial fetch
  useEffect(() => {
    fetchAbsences();
  }, [IsEmployee]);


  useEffect(() => {
    if (IsEmployee && activeTab === 'overview') {
      setActiveTab('add'); // or 'absences', depending on your desired default
    } else if (!IsEmployee && activeTab === 'add') {
      setActiveTab('overview'); // Set to 'overview' when switching to non-employee
    }
  }, [IsEmployee]);

  return (
    <div >
      <PageHeader title="Day Off"
        subtitle="Manage day off requests and balances"
        actions={
          <>
            <ElegantAddButton text="Add Day Off" onClick={() => navigate('/day_off/add')} />
            <ElegantAddButton text="Confirm Day Off" onClick={() => navigate('/unconfirmed', { state: { absenceType: 'DAY_OFF' } })} />
          </>
        } />
      {/* <Divider/> */}
      <div id="absences-container">
        <Absence
          filters={filters}
          setFilters={setFilters}
          setSelectedAbsence={setSelectedAbsence}
          absences={absences}
          setSelectedUpload={setSelectedUpload}
          setSelectToStore={setSelectToStore}
          unconfirmed={false}
          fetchAbsences={fetchAbsences}
          IsEmployee={IsEmployee}
        />
      </div>

      {selectedAbsence && (
        <AbsenceDetailsModal
          selectedAbsence={selectedAbsence}
          setSelectedAbsence={(val) => {
            //console.log('Set selectedAbsence to:', val); // Debug
            setSelectedAbsence(val);
          }}
          fetchAbsences={fetchAbsences}
          IsEmployee={IsEmployee}
        />
      )}

      {selectedUpload && (
        <JustificationUploadModal
          selectedUpload={selectedUpload}
          setSelectedUpload={(val) => {
            setSelectedUpload(val);
          }}
          fetchAbsences={fetchAbsences}
        />
      )}
      {/* Day Details Modal for Calendar */}
      <DayDetailsModal
        open={showDayDetailsModal}
        onClose={() => setShowDayDetailsModal(false)}
        selectedDate={selectedCalendarDate}
        dayAbsences={dayAbsences}
        employees={employees}
      />

      {selecteToStore && (<AbsenceDetailsDialog
        open={Boolean(selecteToStore)}
        onClose={() => setSelectToStore(null)}
        absence={selecteToStore}
        setSelectToStore={setSelectToStore}
        fetchAbsences={fetchAbsences}
      />)}
    </div>
  );
};

export default DayOff;